module.exports = __webpack_public_path__ + "images/Hidden.c35066ef3ad90ecfde35c47e468f8fdb.svg";